import Divider from "material-ui/Divider";
import IconButton from "material-ui/IconButton";
import Icon from "material-ui/Icon";
import CloseIcon from "material-ui-icons/Close";
import React from "react";

const useStyles = () => {
  return {
    root: {
      display: "flex",
      alignItems: "center",
      flexDirection: "row",
    },
    childrenContainer: {
      display: "flex",
      flexGrow: 1,
      paddingLeft: "16px",
    },
    divider: (theme) => ({
      borderColor: "black",
      borderBottomWidth: theme.borderWidth.medium,
    }),
    closeIconButton: {
      p: 0,
    },
  };
};

export const DrawerHeader = ({
  onClose,
  CloseIconButtonProps,
  dividerProps,
  children,
  ...containerProps
}) => {
  const styles = useStyles();
  const divider = children && <Divider {...dividerProps} sx={styles.divider} />;
  return (
    <div className="DS-DrawerHeader">
      <div {...containerProps} style={styles.root}>
        <div style={styles.childrenContainer}>{children}</div>

        {onClose && (
          <IconButton
            size="small"
            {...CloseIconButtonProps}
            style={styles.closeIconButton}
            onClick={onClose}
          >
            <CloseIcon style={{ height: 24, width: 24 }} />
          </IconButton>
        )}
      </div>
      {divider}
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/DishImageGallery/DrawerHeader.js